//modules
import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

// states
import { NotificationsState } from 'src/app/core/notifications/state/notifications.state';
import { UserState } from 'src/app/core/user/state/user.state';
// models
import { NotificationModel } from 'src/app/core/notifications/models/notification.model';
import { MenuItem } from './menu.model';
import { MENU } from './menu';

//types
import { User } from 'src/app/core/user/user.types';

// services
import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationService } from 'src/app/core/notifications/service/notification.service';
import { PageableResponse } from 'src/app/core/models/pageable-response.model';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {

  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  userAvatar: any;
  userData: User;
  isNewNotification: boolean = false;
  unReadNotificationsCount: number
  notificationsList: NotificationModel[];
  currentLang: string
  manualBankStatementEnabled: boolean;
  businessAccountStatus: string;

  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private _authService: AuthService, private _route: Router,
    public _translate: TranslateService, private _notificationService: NotificationService) {
    //get current lang
    this.currentLang = localStorage.getItem('language')

    // translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    // check unread notifications count once user login
    this.loadUnReadNotificationsCount()

    this._route.events
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((event) => {
        if (event instanceof NavigationEnd && event.url === '/notifications') {
          this.unReadNotificationsCount = 0;
        }
      });


    this._translate.onLangChange
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        // When the language changes
        this.currentLang = localStorage.getItem('language');
      });
    // Menu Items
    this.menuItems = MENU;

    // Subscribe To The User state
    UserState.getUserState()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (user: User) => {
          this.userData = user;

        });


    // Subscribe To The User Photo State
    UserState.getUserPhotoState()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((userAvatar: SafeUrl) => {
        this.userAvatar = userAvatar;
      })

    // Get Socket Notification State    
    NotificationsState.getSocketNotificationState()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: NotificationModel) => {
        if (data) {
          this.isNewNotification = true
          //get unread notifications count once system get updates from '/user/queue/notifications'
          this.loadUnReadNotificationsCount()
        }
      })

  }


  /**
* Load Notifications Method
*/

  loadUnReadNotificationsCount() {
    const page = 0
    const size = 10
    this._notificationService.getAllNotifications(page, size).subscribe(
      (res: PageableResponse<NotificationModel[]>) => {
        // NotificationsState.setNotificationsState(res)
        if (res?.content) {
          this.unReadNotificationsCount = res.content.filter(item => !item.readStatus).length;
        }
      }
    )
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    this.initActiveMenu();
  }

  /**
 * Remove Activation Function
 * @param items
 */

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  /**
* Toggle Sub Item Function
* @param event
*/
  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded', "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  /**
* Toggle Extra Sub Item Function
* @param event
*/
  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute('aria-expanded', "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.toggle("show");
    }
  };

  // Click wise Parent active class add
  /**
* Toggle Parent Item Function
* @param event
*/
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  /**
* Toggle Item Function
* @param event
*/
  toggleItem(event: any, item: MenuItem) {
    this._route.navigateByUrl(item.link)
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });
      (isMenu) ? isMenu.classList.add('show') : null;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const iconItems = Array.from(ul.getElementsByTagName("a"));
        let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
        activeIconItems.forEach((item: any) => {
          item.setAttribute('aria-expanded', "false")
          item.classList.remove("active");
        });
      }
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      if (isCurrentMenuId) {
        this.activateParentDropdown(isCurrentMenuId);
      }
    }
  }

  /**
* Activate Parent Dropdown Function
* @param item
*/
  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  /**
* Update Active Function
* @param event
*/
  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  /**
* Init Active Menu Function
*/
  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }


  /**
    * Logout the user
    */
  logout() {
    this._authService.signOut();
    this._route.navigate(['/auth']);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
